import {
    DIRECTION,
    POSITION,
    STACK,
    SALARY,
    CURRENCY,
    CITY,
    ONSITE,
    VACANCIES,
} from "../types";

const initialState = {
    direction: { id: 0, },
    position: '',
    stack: [],
    salary: 0,
    currency: 'RUB',
    city: {},
    onsite: '',
    vacancies:[],
    experiences: [],
}

export default function filterReducer(
    state = initialState,
    { data, type, payload, bool, code }
) {
    switch (type) {
        case DIRECTION: {
            return {
                ...state,
                direction: data,
            }
        }

        case POSITION: {
            return {
                ...state,
                position: data,
            }
        }

        case STACK: {
            return {
                ...state,
                stack: data,
            }
        }

        case SALARY: {
            return {
                ...state,
                salary: data,
            }
        }

        case CURRENCY: {
            return {
                ...state,
                currency: data,
            }
        }

        case CITY: {
            return {
                ...state,
                city: data,
            }
        }

        case ONSITE: {
            return {
                ...state,
                onsite: data,
            }
        }

        case VACANCIES: {
            return {
                ...state,
                vacancies: data,
            }
        }

        default:
            return state
    }
}